import { Button, ControlGroup, FormGroup, InputGroup } from "@blueprintjs/core";
import _, { Dictionary } from "lodash";
import React from "react";
import { gen_id } from "../../../utils/id";
import { FormItemBuilder } from "../Form";
import { InputFormState } from "../InputForm";

export interface FieldListItem {
  id: string;
  key: string;
  value: string;
  key_field_id?: number;
  unit?: string;
  required: boolean;
}

export interface CustomFieldBuilderBundle<ObjectType> {
  update_value: (v: any) => void;
  update_key: (k: any) => void;
  update_unit: (u: any) => void;
  item: FieldListItem;
  state: InputFormState<ObjectType>;
  submitting: boolean;
  removeField: () => void;
  build_remove_button: () => void;
}

export interface CustomFieldBuilder {
  use: (item: FieldListItem) => boolean;
  render: (bundle: CustomFieldBuilderBundle<any>) => React.ReactNode;
}

const customFieldBuilder: CustomFieldBuilder[] = [];

export const RegisterCustomFieldBuilder = (builder: CustomFieldBuilder) => {
  customFieldBuilder.push(builder);
};

export const ArticleFieldListBuilder: FormItemBuilder<Dictionary<string>> = ({
  field_properties: prop,
  field_index: index,
  update_value: updateValue,
  form_state: state,
  form_submitting: submitting,
}) => {
  console.log("field list builder", prop, index);

  console.log("index, state", index, state);
  let current_value = _.get(
    state,
    ["values", index],
    []
  ) as Array<FieldListItem>;

  console.log("current value", current_value);

  const rows: React.ReactNode[] = [];

  _.forEach(
    _(current_value).orderBy(["required", "key"], ["desc", "asc"]).value(),
    (item, key) => {
      console.log("building row for", item, key);

      // if (prop.ignoreItemKeys?.indexOf(key) != -1) return;

      const builder = _.find(customFieldBuilder, (builder) =>
        builder.use(item)
      );

      const update_item_value = (new_value: any) => {
        // console.log("updating item value");
        // console.log("new_value", new_value);
        // console.log("current_value", current_value);

        const new_values = _.cloneDeep(current_value);
        let target_item = _.find(new_values, { id: item.id });
        // console.log("target_item", target_item);
        if (target_item) {
          target_item.value = new_value;
          updateValue(new_values);
        }
      };

      const update_item_key = (new_key: any) => {
        const new_values = _.cloneDeep(current_value);
        let target_item = _.find(new_values, { id: item.id });
        if (target_item) {
          target_item.key = new_key;
          updateValue(new_values);
        }
      };

      const update_item_unit = (unit: any) => {
        const new_values = _.cloneDeep(current_value);
        let target_item = _.find(new_values, { id: item.id });
        if (target_item) {
          target_item.unit = unit;
          updateValue(new_values);
        }
      };

      const remove_item_field = () => {
        updateValue(
          _(current_value)
            .clone()
            .filter((v) => v.id !== item.id)
        );
      };

      const build_remove_button = (item: FieldListItem) => (
        <Button
          disabled={submitting || item.required}
          intent="danger"
          icon="cross"
          onClick={() => remove_item_field()}
        />
      );

      if (builder) {
        rows.push(
          <div key={item.id}>
            {builder.render({
              item,
              update_value: update_item_value,
              update_key: update_item_key,
              update_unit: update_item_unit,
              removeField: remove_item_field,
              build_remove_button: () => build_remove_button(item),
              state,
              submitting,
            })}
          </div>
        );
      } else {
        rows.push(
          <ControlGroup style={{ marginBottom: 10 }} key={item.id}>
            <InputGroup
              disabled={submitting}
              type="text"
              onChange={(e) => update_item_key(e.currentTarget.value)}
              value={item.key}
            />
            <InputGroup
              fill
              disabled={submitting}
              type="text"
              onChange={(e) => update_item_value(e.currentTarget.value)}
              value={
                typeof item.value == "object"
                  ? JSON.stringify(item.value)
                  : item.value
              }
            />
            {build_remove_button(item)}
          </ControlGroup>
        );
      }
    }
  );

  rows.push(
    <Button
      disabled={submitting}
      key={"add_" + index}
      icon="plus"
      onClick={() => {
        let v = _.clone(current_value);
        if (!_.isArray(v)) {
          v = [];
        }
        v.push({
          id: gen_id(),
          key: "key",
          value: "value",
          required: false,
        });
        updateValue(v);
      }}
    ></Button>
  );

  return (
    <FormGroup
      label={prop.label}
      key={index}
      // style={{ marginBottom: 10 }}
    >
      {rows}
    </FormGroup>
  );
};
